/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Edit1Inputs */

const id_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunting`)
};

const ms_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunting`)
};

const da_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rediger`)
};

const de_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const en_us2_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const es_es2_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const es_mx2_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const fil_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-edit`)
};

const fr_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const it_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const hu_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szerkesztés`)
};

const nl_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerken`)
};

const no_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rediger`)
};

const pl_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj`)
};

const pt_br2_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const pt_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const ro_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editează`)
};

const fi_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkaa`)
};

const sv_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redigera`)
};

const vi_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉnh sửa`)
};

const tr_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenle`)
};

const cs_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit`)
};

const bg_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактиране`)
};

const ru_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать`)
};

const uk_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редагувати`)
};

const ar_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحرير`)
};

const hi_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादित करें`)
};

const th_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แก้ไข`)
};

const ja_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集`)
};

const zh_cn2_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const zh_hant1_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編輯`)
};

const ko_offerdetail_reviews_edit1 = /** @type {(inputs: Offerdetail_Reviews_Edit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Offerdetail_Reviews_Edit1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_edit1 = /** @type {((inputs?: Offerdetail_Reviews_Edit1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Edit1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_edit1(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_edit1(inputs)
	if (locale === "da") return da_offerdetail_reviews_edit1(inputs)
	if (locale === "de") return de_offerdetail_reviews_edit1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_edit1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_edit1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_edit1(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_edit1(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_edit1(inputs)
	if (locale === "it") return it_offerdetail_reviews_edit1(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_edit1(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_edit1(inputs)
	if (locale === "no") return no_offerdetail_reviews_edit1(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_edit1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_edit1(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_edit1(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_edit1(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_edit1(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_edit1(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_edit1(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_edit1(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_edit1(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_edit1(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_edit1(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_edit1(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_edit1(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_edit1(inputs)
	if (locale === "th") return th_offerdetail_reviews_edit1(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_edit1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_edit1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_edit1(inputs)
	return ko_offerdetail_reviews_edit1(inputs)
});
export { offerdetail_reviews_edit1 as "offerDetail.reviews.edit" }